import qs from 'qs'

import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'

import { ITrainingType, IGetRequestObject } from '../../interfaces'

type QueryObject = {
  activeOnly?: boolean
}

const getTrainingTypesDetailsRequest = (
  params: undefined,
  queryObject: QueryObject | undefined,
): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })

  return {
    method: 'get',
    url: `${config.baseUrl}/TrainingTypes/details${queryString}`,
  }
}

const useTrainingTypesDetailsQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ITrainingType[] | undefined
>({
  getRequest: getTrainingTypesDetailsRequest,
  getQueryKey: (params, queryObject) => [
    'training-types-details',
    queryObject?.activeOnly,
  ],
})

const useTrainingTypesDetailsQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ITrainingType[] | undefined, Error>,
) => {
  const trainingTypesDetailsQuery = useTrainingTypesDetailsQueryBase(undefined, queryObject, options)

  return { ...trainingTypesDetailsQuery }
}
export default useTrainingTypesDetailsQuery
